import { type FilterTypesMap, FilterType } from "utils/filterUtils";
import type { Link } from "../../../../components/ExpandableItems/types";
import type { Removable, WithId } from "../../../../types";
import type { FileLike, Group, User } from "../../../../interfaces";

export interface ScormOverview {
  id: number;
  title: string;
  thumbnailUrl: string;
  canBePublished: boolean;
  hasBeenPublished: boolean;
  description: string;
  isDraft: boolean;
  isPurchased: boolean;
  ownerId: number;
  publisher: string;
  dateCreated: string;
  dateModified: string;
  isLoading?: boolean;
  canBeDeleted: boolean;
  dependencies?: {
    assignmentsCount: number;
    flowsCount: number;
    packsCount: number;
  };
  visibility: boolean;
}

export enum ScormFiltersEnum {
  Tags = "tags",
  SoftwareApplications = "softwareApplications",
  Labels = "labels",
  Packs = "packIds",
  Publishers = "publisherIds",
  DateCreated = "dateCreated",
  DateModified = "dateModified",
}

export const filterTypes: FilterTypesMap<ScormFiltersEnum> = {
  dateCreated: FilterType.DateRange,
  dateModified: FilterType.DateRange,
  labels: FilterType.Array,
  packIds: FilterType.Array,
  publisherIds: FilterType.Array,
  softwareApplications: FilterType.Array,
  tags: FilterType.Array,
};

export interface Settings {
  packs: Link[];
  flows: Link[];
  labels: string[];
  softwareApplications: string[];
}

export interface FormFields {
  title: string;
  fileName: string;
  description: string;
  thumbnailUrl: string;
  uploadedFiles: FileLike[];
}

interface People extends Removable, WithId {
  priorityLevelId: number;
  editable: boolean;
  permissionIssuedDate: Date;
  inherited: boolean;
}

export interface ScormUser extends User, People {
  userId: number;
  isCompleted: boolean;
  expirationDate?: string;
}

export interface ScormGroup extends Group, People {
  groupId: string;
}

export type EntityMode = "create" | "edit";
